<style lang="scss" scoped>
.questionnaire {
  width: 100%;
  height: 100%;
  .poster {
    width: 100%;
    height: 100%;
    background: url("~@/assets/images/ques_bg_lt.png") no-repeat left top,
      url("~@/assets/images/ques_bg_rb.png") no-repeat right bottom,
      radial-gradient(
        50% 50% at 50% 50%,
        rgb(255, 255, 255),
        rgb(235, 243, 250) 100%
      );
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h2 {
      font-size: 32px;
      line-height: 40px;
      color: #191919;
      text-align: center;
    }
    .welcome {
      font-size: 20px;
      line-height: 32px;
      color: #191919;
      text-align: justify;
      margin: 24px 0;
      text-align: center;
    }
    .el-button {
      width: 254px;
      height: 50px;
      font-size: 18px;
      color: #fff;
      border-radius: 25px;
      background: linear-gradient(
        180deg,
        rgb(57, 86, 165),
        rgb(46, 67, 123) 96.947%
      );
      border: none;
    }
    .icon-chenggong {
      width: 115px;
      height: 115px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 122px;
      color: #3956a5;
      margin-bottom: 25px;
    }
  }
}
</style>

<template>
  <section class="questionnaire">
    <!-- 题目 -->

    <queslist v-if="questionnaire_status == 1 && questionnaire_answer_status == 0" :ques="ques_data" :tqId="tq_id" :twsId="tws_id" :inCn="in_cn" @submit="quesSub" />
    <queslogin v-else-if="questionnaire_status == 1 && questionnaire_answer_status == 1" :tqId="tq_id" :twsId="tws_id" :taId="ta_id" :inCn="in_cn" @submit="loginSub" />
 

    <!-- 封面（欢迎、结束） -->
    <div class="poster" v-else>
      <template v-if="questionnaire_status == 0">
        <div style="width: 75%;">
        <h2>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ questionnaire_data.tq_title }}</h2>
        <p class="welcome">
          {{ questionnaire_data.tq_desc }}
        </p>
        </div>
        <el-button @click="changeStep(1)">{{ $t('开始填写') }}</el-button>
      </template>
      <template v-if="questionnaire_status == 2">
        <font class="iconfont icon-chenggong"></font>
        <h2 style="width: 80%;text-align: center;">{{ questionnaire_data.tq_conclusion }}</h2>
      </template>
    </div>
    <div>
 
    </div>
  </section>
</template>

<script>
// 接口
import { getInfo,getQuestionData,get_question_website ,answerAdd, isAnswer,isAnswerLogin} from "@api/questionnaire";
import Queslist from "./components/queslist";   
import Queslogin from "./components/login";
import { getMyInfo } from "@api/home";
import Cookies from 'js-cookie';
export default {
  name: "Questionnaire",
  components: {
    Queslist,
    Queslogin,
  },
  data() {
    return {
      questionnaire_status: 0, // 问卷作答状态 0: 未开始 1: 进行中 2: 已结束

      // 答题状态
      questionnaire_answer_status: 0, //0 题目  1 登录

      ques_data: [], // 问卷题目数据
      tq_id:'' , // 问卷id
      ta_id:'',
      questionnaire_data:[],
      tws_id:1,
      in_cn:1,

      formDate:{
        ques:[],
        ta_id:this.ta_id,
        userFormData:{}
      }
    };
  },
  created() {
    this.ta_id = this.$route.params.ta_id;
  },
  mounted() {
    this.getData();
    this.getUserInfo();
  },
  methods: {
    async getData() {
      if(this.ta_id){
        const reswebsite = await get_question_website({ta_id:this.ta_id});
        if (reswebsite.status == 200) {
          localStorage.setItem('currentLanguage', reswebsite.data.currentLanguage);
          this.tws_id = reswebsite.data.tws_id
          this.in_cn = reswebsite.data.in_cn
        }
        const res = await getInfo({id:this.ta_id});
        if (res.status == 200) {
            this.questionnaire_data = res.data;
            this.tq_id = res.data.tq_id;
            this.ta_id = res.data.ta_id;
        }
        const resQue = await getQuestionData({tq_id:this.tq_id});
        if (resQue.status == 200) {
            this.ques_data = resQue.data.data;
        }
      }
      
    },
    /**
     * 获取用户信息
     */
     async getUserInfo() {
      try {
        const res = await getMyInfo();
        if (res.status == 200) {
          this.userinfo = res.data;
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
        this.userinfo = {};
      }
    },
    async QuestionData() {
      
    },
    changeStep(status) {
      
      
      if (status == 1) {
        /* 开始答题，请求问卷题目数据 */
        if(this.questionnaire_data.length == 0){
          this.$message.warning(this.$t('未设置调查问卷'));
          return false;
        }
        if(this.questionnaire_data.activity_ta_status != 60 && this.questionnaire_data.ta_id > 0){
          this.$message.warning(this.$t('活动审核未通过，不能填写问卷'));
          return false;
        }
        let currentTimestamp = Math.floor(Date.now() / 1000);
        // 将过期日期设置为当天的 23:59:59，确保当天还能继续填写问卷
        const expirationDate = new Date(this.questionnaire_data.tq_expiration_date * 1000);
        expirationDate.setHours(23, 59, 59, 999); // 设置为当天的最后一秒
        const expirationTimestamp = Math.floor(expirationDate.getTime() / 1000);
        if(currentTimestamp > expirationTimestamp){
					this.$message.warning(this.$t('调查问卷已过期'));
          return false;
				}
      }
      this.questionnaire_status = status;
    },
    quesSub(e) {
      //console.log(e,"ddddddddd"); // 问卷提交结果
      /* 成功切换下一步 */
      this.questionnaire_answer_status = 1;

      this.formDate.ques = e.ques;
      // 页面滑动到顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      // this.changeStep(2);
    },

    async loginSub(e){
      // console.log(e,"ddddddddd");
      let params = e;
      if(this.ta_id == 0){
        var tqau_tq_type = 30;
        var tqau_content_id = this.tq_id;
      }else{
        var tqau_tq_type = 10;
        var tqau_content_id = this.ta_id;
      }
      // console.log(params)
      // return false;
      
      

      try {
        console.log(params.user_info.user_id)
        if(params.user_info.user_id != ''){
          // 提交前检查是否已回答过（后端会判断是否允许多次提交）
          const checkParams = {
            user_id: params.user_info.user_id,
            tq_id: this.tq_id,
          };
          const checkRes = await isAnswerLogin(checkParams);
          if(checkRes.status !== 200){
            
            return false;
          }
        }
          let formData = {
            userFormData: params.user_info,
            ques: this.formDate.ques,
            tq_id: this.tq_id,
            tqau_tq_type: tqau_tq_type,
            tqau_content_id: tqau_content_id
          }

          const res = await answerAdd(formData);
          // console.log("....................")
          this.changeStep(2);
          if(res.data.tre_ep !== 0){
            if (!this.userinfo.user_id) {
              Cookies.set('accessToken',res.data.token);
            }
            return this.$navigate('/rafflelandingpage?tre_ep=' + res.data.tre_ep + '&trer_source_type=40&trer_source_id='+this.tq_id, null, false);
          }
      } catch (error) {
        console.error("Submission failed", error);
        this.$message.error(error.message || this.$t('提交失败，请重试'));
      }

   
    },
  },
};
</script>
